import React, { Fragment, useState, useEffect } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployerStats } from '../../redux/actions/employer/getEmployerStats';
import { setActiveEmployerFilter } from '../../redux/slices/employer.slice';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
export const filterEmployer = [
  {
    label: 'Все',
    value: 'all',
    statValue: 'total',
    params: { is_active: true, is_verified: true, is_blocked: false },
    emptyText: 'Контрагентов нет',
  },
  {
    label: 'Без трансляции',
    value: 'noBroadcast',
    statValue: 'inactive',
    params: { is_broadcast: false, is_active: true, is_verified: true },
    emptyText: 'Контрагентов нет',
  },
  {
    label: 'Заявки',
    value: 'applicant',
    statValue: 'requests',
    params: { is_active: true, is_verified: false, verification_status: 'review' },
    emptyText: 'Контрагентов нет',
  },
  {
    label: 'Заблокированные',
    value: 'blocked',
    statValue: 'blocked',
    params: { is_blocked: true },
    emptyText: 'Контрагентов нет',
  },
];
function ContractorMenu({ sendDataToParent }) {
  const {
    getEmployerStats: { data: getEmployerStatsData, error: getEmployerStatsError, loading: getEmployerStatsLoading },
    activeEmployerFilter,
  } = useSelector((state) => state.employer);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEmployerStats());
  }, []);

  const handleMobileTabList = (e) => {
    // setActive(e.target.name);
    // localStorage.setItem('contractorTabState', e.target.name);
    // sendDataToParent(e.target.name);
  };

  return (
    <div className="flex w-full justify-between">
      <ul className="hidden md:flex list-none gap-3">
        {filterEmployer?.map((item) => (
          <li
            className={`cursor-pointer ${activeEmployerFilter.value === item.value ? 'font-bold underline' : ''}`}
            onClick={() => {
              dispatch(setActiveEmployerFilter(item));
            }}>
            {`${item.label}: ${getEmployerStatsData?.[item.statValue] ?? ''}`}
          </li>
        ))}
      </ul>
      <div className="flex md:hidden">
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
              {`${activeEmployerFilter.label}: ${getEmployerStatsData?.[activeEmployerFilter.statValue]}`}
              <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
            </Menu.Button>
          </div>

          <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
            <Menu.Items className="absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                {filterEmployer?.map((item) => (
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        className={classNames(item.value == activeEmployerFilter.value ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}
                        name="all"
                        onClick={() => {
                          dispatch(setActiveEmployerFilter(item));
                        }}>
                        {`${item.label}: ${getEmployerStatsData?.[item.statValue]}`}
                      </Link>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </div>
  );
}

export default ContractorMenu;
